export function setCurrentYear() {
  const el = document.querySelector(".current-year")

  if (!el) return

  el.innerHTML = new Date().getFullYear()
}